import React from 'react'
import ContactCard from './ContactCard'

export default function Contact() {
    document.title = "Portfolio - CONTACT"

    return (
        <section className="contact-us">
            <h4 className="after-line">Contact</h4>
            <h3 className="heading">Contact me</h3>
            <p className="contact-msg">
                    If you need to contact me, please don't hesitate to send an email to the following address...
            </p>
            <div className="cards">
                <ContactCard
                    icon={<>
                        <i className="fa-solid fa-location-dot"></i>
                    </>}
                    text="My Address"
                    link={<>
                        <a href="https://goo.gl/maps/VnKLpkJmP9dQmrak9">New Delhi, 110062</a>
                    </>}
                />
                <ContactCard
                    icon={<>
                        <i className="fa-solid fa-share-nodes"></i>
                    </>}
                    text="Social Profile"
                    link={<>
                        <a href="https://github.com/adarshmaurya54/" target="_blank" rel="noreferrer"><i className="fa-brands fa-square-github"></i></a> <a href="https://www.linkedin.com/in/adarshmaurya54" target="_blank" rel="noreferrer"><i
                            className="fa-brands fa-linkedin-in"></i></a><a href="https://www.instagram.com/adarshmaurya_54/" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"></i></a>
                    </>}
                />
                <ContactCard
                    icon={<>
                        <i className="fa-solid fa-envelope"></i>
                    </>}
                    text="Email"
                    link={<>
                        <a href="mailto:54.adarsh.maurya@gmail.com">54.adarsh.maurya@gmail.com</a>
                    </>}
                />
                <ContactCard
                    icon={<>
                        <i className="fa-solid fa-phone-volume"></i>
                    </>}
                    text="Call Me"
                    link={<>
                        <a href='/'>+91 9555292528</a>
                    </>}
                />
                {/* <form spellCheck={false} action="" method="post">
                    <div className="msg">
                        <i className="fa-solid fa-triangle-exclamation"></i> The service is currently unavailable.
                    </div>
                    <div className="input-field">
                        <div className="error error1">
                            <span className="error-msg1"></span>
                        </div>
                        <input type="text" name="name" required />
                        <label>Name <span className="Name"></span></label>
                        <i className="fa-solid fa-user right-icon"></i>
                    </div>
                    <div className="input-field">
                        <div className="error error2">
                            <span className="error-msg2"></span>
                        </div>
                        <input type="text" name="email" required />
                        <label>Email <span className="Email"></span></label>
                        <i className="fa-solid fa-envelope right-icon"></i>
                    </div>
                    <div className="input-field">
                        <div className="error error3">
                            <span className="error-msg3"></span>
                        </div>
                        <input type="text" name="subject" required />
                        <label>Subject <span className="Subject"></span></label>
                        <i className="fa-solid fa-book right-icon"></i>
                    </div>
                    <div className="input-field textarea-filed">
                        <div className="error error4">
                            <span className="error-msg4"></span>
                        </div>
                        <textarea rows="5" required></textarea>
                        <label>Message <span className="Message"></span></label>
                        <i className="fa-solid fa-message right-icon"></i>
                    </div>
                    <div className="submit-btn">
                        <button type="button">SEND MESSAGE</button>
                    </div>
                </form> */}


            </div>
        </section>
    )
}
